import * as React from "react";
import FormAttributeComponent from "./FormAttributeComponent";
import InvalidateQualifierModal from "./InvalidateQualifierModal";
import AddAttributeModal from "./AddAttributeModal";
import { Form, Tooltip } from "antd";
import { SelectExistingQualifierFormProps } from "./SelectExistingQualifierForm";
import AttributeSelectionForm from "./AttributeSelectionForm";
import { IAttribute } from "../../../model/formconfiguration/Attribute";
import { ISection } from "../../../model/formconfiguration/Section";
import Text from "antd/lib/typography/Text";
import { IFormConfigSectionQualifier } from "../../../model/formconfiguration/FormConfigSectionQualifier";
import { IFormConfigQualifierAttribute } from "../../../service/formconfiguration/FormConfigQualifierAttribute";
import CreateFormConfigQualifierAttributeForm, {
  CreateFormConfigQualifierAttributeFormProps
} from "./CreateFormConfigQualifierAttributeForm";

export interface State {}

export interface Props {
  formConfigSectionQualifier: IFormConfigSectionQualifier;
  selectedFormElement: any;
  onClick: any;
  translate: any;
  invalidateQualifier: any;
  createFormConfigQualifierAttribute(
    parentFormConifgSectionQualifier: IFormConfigSectionQualifier,
    formConfigQualifierAttribute: IFormConfigQualifierAttribute
  ): any;
  attributes?: IAttribute[];
  invalidateAttribute: any;
  hideAddAttributeModal: any;
  hideRemoveQualifierModal: any;
  addAttributeModalVisible: any;
  removeQualifierModalVisible: any;
  hideInvalidateAttributeModal: any;
  invalidateAttributeModalVisible?: any;
  parentSection: ISection;
  isSelectedComponent: any;
}

export default class FormQualifierComponent extends React.Component<
  Props,
  State
> {
  render() {
    const {
      formConfigSectionQualifier,
      selectedFormElement,
      onClick,
      translate,
      invalidateQualifier,
      createFormConfigQualifierAttribute,
      attributes,
      invalidateAttribute,
      hideAddAttributeModal,
      hideRemoveQualifierModal,
      addAttributeModalVisible,
      removeQualifierModalVisible,
      hideInvalidateAttributeModal,
      invalidateAttributeModalVisible,
      parentSection,
      isSelectedComponent
    } = this.props;

    const CreateAttributeFormComponent = Form.create<
      CreateFormConfigQualifierAttributeFormProps
    >({})(CreateFormConfigQualifierAttributeForm);

    const AttributeSelectionFormComponent = Form.create<
      SelectExistingQualifierFormProps
    >({})(AttributeSelectionForm);

    const renderAttributes = () => {
      let attributes: JSX.Element[] = [];
      if (formConfigSectionQualifier && formConfigSectionQualifier.attributes) {
        formConfigSectionQualifier.attributes.sort(function (a, b) {
          return a.orderNumberInsertDisplay - b.orderNumberInsertDisplay;
        });
        formConfigSectionQualifier.attributes.forEach((attribute) => {
          attributes.push(
            <FormAttributeComponent
              key={attribute.attributeCode}
              formConfigAttribute={attribute}
              selectedFormElement={selectedFormElement}
              onClick={onClick}
              translate={translate}
              invalidateAttribute={invalidateAttribute}
              hideInvalidateAttributeModal={hideInvalidateAttributeModal}
              invalidateAttributeModalVisible={invalidateAttributeModalVisible}
              maxNumber={parentSection.maxNumber}
              isSelectedComponent={isSelectedComponent}
              width={formConfigSectionQualifier.width}
            />
          );
        });
      }
      return attributes;
    };

    const handleOnClickEvent = (e) => {
      onClick(formConfigSectionQualifier);
      e.stopPropagation();
    };

    return (
      <Tooltip title={formConfigSectionQualifier.tooltip} mouseEnterDelay={0.5}>
        <div
          className={`form-qualifier ${
            isSelectedComponent(formConfigSectionQualifier) &&
            "form-qualifier-selected"
          }`}
          onClick={handleOnClickEvent}
        >
          <div
            className={"qualifier-title-inline"}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <h3 style={{ marginBottom: 0 }}>
              {`${
                formConfigSectionQualifier.orderNumberVisible
                  ? `${parentSection.orderNumber}.${formConfigSectionQualifier.orderNumber}`
                  : ""
              } ${
                formConfigSectionQualifier.labelVisible
                  ? formConfigSectionQualifier.label ||
                    formConfigSectionQualifier.qualifier.name
                  : ""
              }`}
            </h3>
            <Text style={{ fontSize: 12, fontStyle: "italic" }}>
              {formConfigSectionQualifier.additionalComment || ""}
            </Text>
          </div>

          {parentSection.maxNumber === 1 && (
            <div className="attribute-inline"> {renderAttributes()}</div>
          )}
          <InvalidateQualifierModal
            translate={translate}
            visible={
              removeQualifierModalVisible &&
              isSelectedComponent(formConfigSectionQualifier)
            }
            onCancel={hideRemoveQualifierModal}
            onOk={() => {
              if (selectedFormElement) {
                invalidateQualifier(selectedFormElement.id);
              }
              hideRemoveQualifierModal();
            }}
          />
          <AddAttributeModal
            translate={translate}
            visible={
              addAttributeModalVisible &&
              isSelectedComponent(formConfigSectionQualifier)
            }
            onCancel={() => hideAddAttributeModal()}
            CreateAttributeForm={CreateAttributeFormComponent}
            AttributeSelectionForm={AttributeSelectionFormComponent}
            createFormConfigQualifierAttribute={
              createFormConfigQualifierAttribute
            }
            parentQualifier={formConfigSectionQualifier}
            attributes={attributes}
          />
        </div>
      </Tooltip>
    );
  }
}
